export default "__VITE_ASSET__Ck1xyYO5__"